import React from 'react';
import { getContact, getPageContent } from './websiteStyles';
import ShippingGlobe from './ShippingGlobe';
import YardAnimation from './YardAnimation';

const DARK = '#14161C';
const PAPER = '#FAFAF8';
const INK = '#14161C';
const INK2 = '#52545C';
const INK3 = '#8B8D94';
const LINE = '#E5E5E3';
const BLUE = '#2563EB';
const GREEN = '#22C55E';
const heading = '"Inter Tight", sans-serif';
const mono = '"JetBrains Mono", monospace';
const serif = '"Instrument Serif", serif';

/* ShippingGlobe imported from ./ShippingGlobe.jsx */

/* YardAnimation imported from ./YardAnimation.jsx */

function WebsiteAbout() {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 600;
  const c = getContact();
  const cms = getPageContent('website_about') || {};
  const h = cms.hero || {};
  const y = cms.yard || {};

  return (
    <div>
      {/* ═══ Hero with globe ═══ */}
      <section style={{ background: DARK, color: PAPER, position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, opacity: 0.03, pointerEvents: 'none', backgroundImage: `linear-gradient(rgba(250,250,248,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(250,250,248,0.5) 1px, transparent 1px)`, backgroundSize: '80px 80px' }} />
        <div style={{ maxWidth: 1440, margin: '0 auto', padding: '80px 24px 100px', position: 'relative' }}>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? 24 : 48, alignItems: 'center' }} className="ws-about-hero-grid">
            {/* Left text */}
            <div>
              <div style={{ fontFamily: mono, fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'rgba(250,250,248,0.35)', marginBottom: 24, display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ width: 5, height: 5, borderRadius: '50%', background: 'rgba(250,250,248,0.35)' }}></span>
                {h.eyebrow || 'About BigStar'}
              </div>
              {(() => {
                const hl = h.headline || 'From a Sharjah yard to ports across the world.';
                const accent = h.headline_accent_words || 'to ports';
                const pts = hl.split(accent);
                return (
                  <h1 style={{ fontFamily: heading, fontWeight: 700, letterSpacing: '-0.04em', fontSize: 'clamp(36px, 5.5vw, 64px)', lineHeight: 0.95, marginBottom: 28 }}>
                    {pts[0]}
                    <span style={{ fontFamily: serif, fontStyle: 'italic', color: '#60A5FA', fontWeight: 400 }}>{accent}</span>
                    {pts[1] || ''}
                  </h1>
                );
              })()}
              <p style={{ fontSize: 15, color: 'rgba(250,250,248,0.4)', lineHeight: 1.7, maxWidth: 480, marginBottom: 16 }}>
                {h.description || 'BigStar is a used-vehicle and genuine spare-parts yard headquartered in Sharjah, UAE. Every week our containers leave Jebel Ali bound for dealers, garages and private buyers — from East Africa to South America, from the CIS to the Far East.'}
              </p>
              <p style={{ fontSize: 14, color: 'rgba(250,250,248,0.3)', lineHeight: 1.7, maxWidth: 480, marginBottom: 36 }}>
                {h.description2 || "We don't list prices online — every shipment is quoted live based on spec, condition, port-of-discharge and freight. Reach us by WhatsApp or call and we'll come back with numbers the same day."}
              </p>
              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                <a href={`https://wa.me/${c.whatsapp}`} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '14px 28px', borderRadius: 9999, background: GREEN, color: '#fff', fontSize: 14, fontWeight: 600, textDecoration: 'none', fontFamily: heading }}>
                  {h.primary_cta_text || 'Talk to us on WhatsApp'}
                </a>
                <a href="https://maps.app.goo.gl/43xzfyUEJ3KCo1Mt9" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '14px 28px', borderRadius: 9999, background: 'transparent', color: PAPER, fontSize: 14, fontWeight: 500, border: '1px solid rgba(250,250,248,0.15)', cursor: 'pointer', fontFamily: heading, textDecoration: 'none' }}>
                  {h.secondary_cta_text || 'Visit the yard →'}
                </a>
              </div>
            </div>
            {/* Right globe */}
            <div>
              <ShippingGlobe />
              <div style={{ textAlign: 'center', marginTop: 12, fontFamily: mono, fontSize: 10, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'rgba(250,250,248,0.2)' }}>
                Live Shipping Lanes — Origin: Sharjah HQ
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ Yard Section ═══ */}
      <section style={{ maxWidth: 1440, margin: '0 auto', padding: '80px 24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1.2fr', gap: isMobile ? 24 : 48, alignItems: 'center' }} className="ws-about-yard-grid">
          {/* Left info */}
          <div>
            <div style={{ fontFamily: mono, fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: BLUE, marginBottom: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ width: 5, height: 5, borderRadius: '50%', background: BLUE }}></span>
              {y.eyebrow || 'Main Yard'}
            </div>
            <h2 style={{ fontFamily: heading, fontWeight: 700, letterSpacing: '-0.04em', fontSize: 'clamp(28px, 4vw, 44px)', lineHeight: 1, color: INK, marginBottom: 24 }}>
              {y.heading || 'Industrial Area No. 3, Sharjah.'}
            </h2>
            <p style={{ fontSize: 15, color: INK2, lineHeight: 1.7, maxWidth: 420, marginBottom: 28 }}>
              {y.description || 'Our yard sits 25 minutes from Jebel Ali Port and 15 from Sharjah Airport — a deliberate location so containers leave fast.'}
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 24 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#EF4444', flexShrink: 0 }}></span>
                <div>
                  <div style={{ fontFamily: heading, fontSize: 14, fontWeight: 600, color: INK }}>{y.address || c.address}</div>
                  <div style={{ fontFamily: mono, fontSize: 11, color: INK3 }}>{y.hours || 'Sat-Thu · 8:00 AM – 9:00 PM'}</div>
                </div>
              </div>
              <div style={{ fontFamily: mono, fontSize: 13, color: INK2, paddingLeft: 18 }}>
                <div>📞 {y.phone1 || c.phone}</div>
                <div style={{ marginTop: 4 }}>📱 {y.phone2 || c.mobile}</div>
              </div>
            </div>
          </div>
          {/* Right yard animation */}
          <YardAnimation />
        </div>
      </section>

      {/* ═══ Process Steps ═══ */}
      <section style={{ background: PAPER, borderTop: `1px solid ${LINE}` }}>
        <div style={{ maxWidth: 1440, margin: '0 auto', padding: '80px 24px' }}>
          <div style={{ fontFamily: mono, fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: INK3, marginBottom: 8 }}>How We Ship</div>
          <h2 style={{ fontFamily: heading, fontWeight: 700, letterSpacing: '-0.04em', fontSize: 'clamp(28px, 4vw, 44px)', lineHeight: 1, color: INK, marginBottom: 48 }}>
            From the yard to your port.
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)', gap: 16 }} className="ws-about-steps-grid">
            {[
              { num: '01', title: 'Inquiry', desc: 'WhatsApp or call — share the make, model, year and destination port.' },
              { num: '02', title: 'Live quote', desc: 'We come back with vehicle photos, condition notes and an all-in CIF/FOB number.' },
              { num: '03', title: 'Loading', desc: 'Containers loaded at our Sharjah yard, sealed and trucked to Jebel Ali.' },
              { num: '04', title: 'On the water', desc: 'Tracking shared end-to-end — documents handled in-house.' },
            ].map(step => (
              <div key={step.num} style={{ padding: 24, borderRadius: 12, border: `1px solid ${LINE}`, background: '#fff' }}>
                <div style={{ fontFamily: mono, fontSize: 12, fontWeight: 600, color: BLUE, marginBottom: 16 }}>{step.num}</div>
                <div style={{ fontFamily: heading, fontSize: 20, fontWeight: 700, color: INK, marginBottom: 8, letterSpacing: '-0.02em' }}>{step.title}</div>
                <div style={{ fontSize: 14, color: INK2, lineHeight: 1.6 }}>{step.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Responsive */}
      <style>{`
        @media (max-width: 968px) {
          .ws-about-hero-grid { grid-template-columns: 1fr !important; }
          .ws-about-yard-grid { grid-template-columns: 1fr !important; }
          .ws-about-steps-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 600px) {
          .ws-about-steps-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
}

export default WebsiteAbout;
